import { Component, Input } from '@angular/core';
import { RentaTotal } from 'src/app/models/reporte-financiero/reporte-financiero.model'

@Component({
  selector: 'app-total-renta',
  templateUrl: './total-renta.component.html',
  styleUrls: ['./total-renta.component.scss']
})
export class TotalRentaComponent {
  @Input() data: RentaTotal | any = null;

  public showData: boolean = false;

  constructor() { }

  ngOnInit(): void {
    if(this.data && Object.keys(this.data).length > 0) {
      this.showData = true;
    }
  }
}
